var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,12h-.5V6.5c0-2.48-2.02-4.5-4.5-4.5h-7c-2.48,0-4.5,2.02-4.5,4.5v5.5h-.5c-1.93,0-3.5,1.57-3.5,3.5v3c0,1.93,1.57,3.5,3.5,3.5H20.5c1.93,0,3.5-1.57,3.5-3.5v-3c0-1.93-1.57-3.5-3.5-3.5ZM5,6.5c0-1.93,1.57-3.5,3.5-3.5h7c1.93,0,3.5,1.57,3.5,3.5v10.5H5V6.5Zm18,12c0,1.38-1.12,2.5-2.5,2.5H3.5c-1.38,0-2.5-1.12-2.5-2.5v-3c0-1.38,1.12-2.5,2.5-2.5h.5v4.5c0,.28,.22,.5,.5,.5h15c.28,0,.5-.22,.5-.5v-4.5h.5c1.38,0,2.5,1.12,2.5,2.5v3Zm-13.85-6.35l2.15-2.15-2.15-2.15c-.2-.2-.2-.51,0-.71s.51-.2,.71,0l2.15,2.15,2.15-2.15c.2-.2,.51-.2,.71,0s.2,.51,0,.71l-2.15,2.15,2.15,2.15c.2,.2,.2,.51,0,.71-.1,.1-.23,.15-.35,.15s-.26-.05-.35-.15l-2.15-2.15-2.15,2.15c-.1,.1-.23,.15-.35,.15s-.26-.05-.35-.15c-.2-.2-.2-.51,0-.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/Rejected.340ef0f3bc02389e5f54a605877d59d2.svg";
export { ForwardRef as ReactComponent };